import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as actions from '../actions'
import * as selectors from '../selectors'

const JodalContainer = ({
  displayModal,
  hideModal,
  View,
  modalData,
  ...restProps
}) => {
  // hideModal when ESC key is pressed
  window.addEventListener('keydown', (event) => {
    if (event.keyCode === 27) {
      hideModal()
    }
  })

  return (
    <div>{displayModal && View && <View {...modalData} {...restProps} />}</div>
  )
}

JodalContainer.displayName = 'JodalContainer'
JodalContainer.propTypes = {
  displayModal: PropTypes.bool.isRequired,
  View: PropTypes.func,
  hideModal: PropTypes.func.isRequired,
  modalData: PropTypes.object,
}

JodalContainer.defaultProps = {
  View: null,
  modalData: {},
}

export default connect(
  (state) => ({
    displayModal: selectors.shouldDisplayModalSelector(state),
    View: selectors.getViewSelector(state),
    modalData: selectors.getDataSelector(state),
  }),
  {
    hideModal: actions.hideModal,
  }
)(JodalContainer)
